<template>
  <div>
    <div class="banner-merchant-container">
      <MultiJumpContainer
        v-if="bannerLayoutList?.length"
        v-for="(item, index) in bannerLayoutList"
        :key="index"
        class="banner-merchant"
        :imgUrl="item.imgUrl"
        :biTag="item.biTag"
        :jumpInfo="{
          jumpUrl: item.jumpUrl,
          appid: item.appid,
          username: item.username,
          path:item.path,
        }"
      >
      </MultiJumpContainer>
    </div>
  </div>
</template>
<script setup lang="ts">
import { MultiJumpContainer  } from '@tencent/wphk-components-multi-jump-container';
import { ModuleName } from '@/types/module-type';
import { useMerchantLayoutInfo } from '../hooks/use-merchant-layout-info';

const props = defineProps<{ moduleName: ModuleName }>();
const { bannerLayoutList } = useMerchantLayoutInfo(props.moduleName);

</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
// 定义一个通用的样式混合
.banner-common(@width, @height) {
  width: @width / @rem;
  height: @height / @rem;
  object-fit: cover;
  box-sizing: border-box;
  margin: 8 / @rem 0 8 / @rem 0;
  /deep/ .jump-img {
    border-radius: 16 / @rem;
  }
}

// 定义一个通用的容器样式混合
.container-common(@direction) {
  display: flex;
  flex-direction: @direction;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16 / @rem;
}

.banner-merchant-container {
  height: 384 / @rem;

  .container-common(column);

  .banner-merchant {
    .banner-common(335, 176);
    margin: 8 / @rem 0 8 / @rem 16 / @rem;
  }

  .banner-merchant:nth-child(1) {
    .banner-common(335, 368);
  }
}

</style>
